// ** React Imports
import { Fragment } from 'react'

// ** Custom Components
import NavbarUser from './NavbarUser'
import NavbarBookmarks from './NavbarBookmarks'
import logo from '../../../../assets/images/iconnect/Group 7.png'

const ThemeNavbar = props => {
  // ** Props
  
  const { skin, setSkin, setMenuVisibility } = props
const currentD = new Date()
const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

// Function to format the date as "dd/mm/yy (Day)"
const formattedDate = ` ${daysOfWeek[currentD.getDay()]}, ${currentD.getDate()}-${currentD.getMonth() + 1}-${currentD.getFullYear()} `

  return (
    <Fragment>
      <div className='bookmark-wrapper d-flex align-items-center'>
        <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
        <img src={logo} width={150} className='logo-mobile' />
        <p>Current Date: {formattedDate}</p>
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  )
}

export default ThemeNavbar
